import { Injectable,Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { APP_CONFIG, IAppConfig } from './../app.config';

@Injectable()
export class RequestService {
    constructor(
        private http: HttpClient, @Inject(APP_CONFIG) private config: IAppConfig) {
    }

    private get _authHeader(): string {
        return `Bearer ${localStorage.getItem('access_token')}`;
    }

    makeRequest(email: string,body: string,studentid:number,appid:number,questionid:number) {
        const formData = new FormData();
        formData.append('email',email);
        formData.append('body',body);
        formData.append('questionid',questionid.toString());
        formData.append('studentid',studentid.toString());
        formData.append('appid',appid.toString());
        return this.http
            .post(`${this.config.apiEndpoint}admin/file-request`, formData, {
                headers: new HttpHeaders().set('Authorization', this._authHeader)
            })
            .catch(this._handleError);
    }

    private _handleError(err: HttpErrorResponse | any) {
        /* if(err.status == 0){
            alert('Please check your internet connection');
        } */

        if (err.status == 401) {
            alert('Your session has expired');
            window.location.href = this.config.apiEndpoint+'/#/login';
        }
        return Observable.throw(err);
    }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/_services/request.service.ts